import { isConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
export const isReportValidForReportGetterStrategy = report => isConfigReport(report) || isRelationalReport(report);